import React from 'react';
import ShipIcon from '@atlaskit/icon/core/migration/release--ship';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useRouteByName } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import messages from './messages.tsx';

type Props = {
	projectKey: string;
	testId: string;
};

export const ReleasesMenuItem = ({ projectKey, testId }: Props) => {
	const { formatMessage } = useIntl();
	const releasesRoute = useRouteByName('project-versions');

	// The route definition will be null when this component is rendered outside
	// of the SPA (e.g. the settings page in Classic projects)
	const menuItemProps =
		releasesRoute !== null
			? {
					to: releasesRoute,
					params: { projectKey },
					prefetch: 'hover' as const,
					query: { selectedItem: 'com.atlassian.jira.jira-projects-plugin:release-page' },
				}
			: {
					href: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:release-page`,
				};

	return (
		<MenuItem
			{...menuItemProps}
			analytics={{ itemId: 'releases' }}
			selectedOn={[
				'project-versions',
				'legacy-project-releases',
				'legacy-project-releases-bamboo',
				'legacy-project-releases-note',
				'legacy-project-releases-note-config',
				'software-release-notes',
				'software-version-detail',
			]}
			iconBefore={<ShipIcon spacing="spacious" label="" />}
			testId={testId}
		>
			{formatMessage(messages.releasesItem)}
		</MenuItem>
	);
};
